import * as signals from "signals";
import {Signals} from "@/Imports";

const newSignal = () => new signals.Signal()

export default {
  loadAssets: newSignal(),
  loadingProgress: newSignal(),
  preloaderAssetsLoadingComplete: newSignal(),
  mainGameAssetsLoadingComplete: newSignal(),
  startGame: newSignal(),
  orientationChanged: newSignal(),

  urlSettings: new signals.Signal (),

  realityCheck: new signals.Signal (),
  realityCheck2: new signals.Signal (),
  gameStarted: new signals.Signal (),
  gameInited: new signals.Signal (),
  loadingCompleted: new signals.Signal(),
  textAssetsLoadingComplete: new signals.Signal (),
  continueBtnClick: new signals.Signal (),
  finishShowingLogo: new signals.Signal (),


  // States
  stateChanged: newSignal(),

  initBegin: newSignal(),
  initFinish: newSignal(),

  idleBegin: newSignal(),
  idleFinish: newSignal(),

  rollRequestBegin: newSignal(),
  rollRequestEnd: newSignal(),

  rollStartBegin: newSignal(),
  rollStartEnd: newSignal(),

  rollFinishBegin: newSignal(),
  rollFinishEnd: newSignal(),



  //MODEL SIGNALS
  notEnoughMoney: new signals.Signal (),
  casinoError: new signals.Signal (),
  hardwareAcceleration: new signals.Signal (),
  graphicsCreated: new signals.Signal (),
  modelInitStored: new signals.Signal (),
  balanceUpdate: new signals.Signal (),
  maxBetSet: new signals.Signal (),
  minBetSet: new signals.Signal (),
  normalBet: new signals.Signal (),
  betChanged: new signals.Signal (),
  initReactUI: new signals.Signal (),
  setWin: new signals.Signal (),
  jackpotUpdated: new signals.Signal (),

  reelsStopComplete: new signals.Signal (),




  //UI Signals
  UIisReady: new signals.Signal (),
  initUI: new signals.Signal (),
  setMuteButtons: new signals.Signal (),
  spinBtnPressed: new signals.Signal (),
  buyBtnPressed: new signals.Signal (),

  requestFullScreen: new signals.Signal (),
  initProgress: new signals.Signal (),

  serverMessage: new signals.Signal (),
  backendMessage: new signals.Signal (),
  gameMessage: new signals.Signal (),
  getBonus: new signals.Signal (),
  getGameInit: new signals.Signal (),

  //SERVER SIGNALS
  initGame: new signals.Signal (),
  spinResponse: new signals.Signal (),
  balanceUpdateBackend: new signals.Signal(),
  buyFreespinResponse: new signals.Signal (),
  balanceResponse: new signals.Signal(),
  sessionTimeout: new signals.Signal (),
  errorConnection: new signals.Signal (),

  symbolTap: new signals.Signal (),
  backgroundTap: new signals.Signal (),

  startSpin: new signals.Signal (),
  stopSpin: new signals.Signal (),

  columnClearFeelOnDown: new signals.Signal (),
  reelJustTouchDown: new signals.Signal (),
  reelStopped: new signals.Signal (),
  reelsStopCompleteReel: new signals.Signal (),

  startShowWinnings: new signals.Signal (),
  startShowCycleWinnings: new signals.Signal (),

  startScatterAnimations: new signals.Signal (),
  startAllAnimations: new signals.Signal (),
  allAnimationsComplete: new signals.Signal (),

  startAnticipation: new signals.Signal (),
  stopAnticipation: new signals.Signal (),
  buyFeatureOpen: new signals.Signal (),

  startAnimation: new signals.Signal (),
  startPaylineAnimation: new signals.Signal (),
  appearAnimation: new signals.Signal (),
  appearStickyAnimation: new signals.Signal (),
  disappearAnimation: new signals.Signal (),

  startScattersAnimations: new signals.Signal (),
  startScatterAnimation: new signals.Signal (),

  introFreespins: new signals.Signal (),
  introFreespinsComplete: new signals.Signal (),
  outroFreespins: new signals.Signal (),
  outroFreespinsComplete: new signals.Signal (),
  buyFreespins: new signals.Signal (),
  buyFreespinsNow: new signals.Signal (),
  buyFreespinsComplete: new signals.Signal (),
  hideMultipliers: new signals.Signal (),

  countingUpComplete: new signals.Signal (),

  paylineAnimationComplete: new signals.Signal (),
  showWinningsComplete: new signals.Signal (),

  scatterAnimationComplete: new signals.Signal (),
  scattersAnimationsComplete: new signals.Signal (),

  showBigWin: new signals.Signal (),
  showingBigWin: new signals.Signal (),
  finishBigWin: new signals.Signal (),
  showBigWinComplete: new signals.Signal (),

  spinCanceled: new signals.Signal (),
  cancelSpin: new signals.Signal (),
  skip: new signals.Signal (),
  skipForBuy: new signals.Signal (),

  //COINS
  accumulatorAction: new signals.Signal (),
  accumulatorActionComplete: new signals.Signal (),
  initAccumulator: new signals.Signal (),
  winningsIncreased: new signals.Signal (),

  //AUTOPLAY
  autoplaySetCondition: new signals.Signal (),
  autoplaySetCount: new signals.Signal (),
  setAutoplay: new signals.Signal (),
  autospinCountChanged: new signals.Signal (),
  autoplayFinished: new signals.Signal (),
  stopAutoplay: new signals.Signal (),

  startCountingUpWinnings: new signals.Signal (),
  winsCountupComplete: new signals.Signal (),
  skipCountingUpWinnings: new signals.Signal (),
  hideCountingUpWinnings: new signals.Signal (),

  startCountingUpInterimWinnings: new signals.Signal (),
  startCountingWinningsGotoMultiplier: new signals.Signal (),

  showBonusReactivated: new signals.Signal (),
  showBonusIntro: new signals.Signal (),
  showBonusOutro: new signals.Signal (),
  showBonusIntroComplete: new signals.Signal (),
  showBonusOutroComplete: new signals.Signal (),
  showBonusRewardsPopup: new signals.Signal (),
  showBonusRewardsPopupComplete: new signals.Signal (),
  bonusCountDownComplete: new signals.Signal (),
  bonusPhotoFinish: new signals.Signal (),

  bonusGame: new signals.Signal (),
  bonusGameComplete: new signals.Signal (),
  startBonusWinAdding: new signals.Signal (),
  startBonusWinAddingComplete: new signals.Signal (),
  expandWild: new signals.Signal (),
  expandWildComplete: new signals.Signal (),
  bonusMultiplierChange: new signals.Signal (),
  bonusMultiplierFly: new signals.Signal (),
  bonusMultiplierShowTextWinScore: new signals.Signal (),

  currentBuyFreebetChanged:  new signals.Signal (),

  musicClick: new signals.Signal (),
  soundClick: new signals.Signal (),
  muteClick: new signals.Signal (),
  errorMessage: new signals.Signal (),
  // SOUNDS
  showBigWinStateChange: new signals.Signal (),
  playSymbolDrop: new signals.Signal (),
  playSymbolCascade: new signals.Signal (),
  playTrail: new signals.Signal (),
  playMultiplierApply: new signals.Signal (),
  playMultiplierLand: new signals.Signal (),
  playMultiplierTrigger: new signals.Signal (),
  playScatterLand: new signals.Signal (),
  playMultiplierTickup: new signals.Signal (),
  playSymbolRemove: new signals.Signal (),
  playWinLevel: new signals.Signal (),
  muteMusic : new signals.Signal (),
  unmuteMusic : new signals.Signal (),
  buyButtonEnabled: new signals.Signal (),
  buyButtonDisabled: new signals.Signal (),

  playBuyIncreas:  new signals.Signal (),
  playBuyDecreaas:  new signals.Signal (),
  playBuyMax:  new signals.Signal (),

  btnClick:  new signals.Signal (),
  quitHandler:  new signals.Signal ()


}
